/**
 * This game originally supported multiple chapters, but the feature was removed.
 * To simplify, we didn't continue with the chapter system, but sadly we still depend on it in some parts on the code base.
 * We now lock the chapter to chapter_1.
 * 
 * If chapters are to be re-implemented, this class should be expanded to keep and manage the available chapters.
 * Similarly to the ScenarioLibrary.
 */
export default class ChapterLibrary {
    constructor() {
        this._currentChapter = {
            id: `chapter_1`,
        };
    }

    getCurrentChapter() {
        return this._currentChapter;
    }
}